module.exports = {
  // base config

  feedback: {
    summary: {
      maxLength: 500,
      minLength: 2,
      minLengthFeedback: "2 characters",
      maxLengthFeedback: "500 characters",
    },
    description: {
      maxLength: 1000,
      minLength: 20,
    },
  },
  google: {
    API_KEY: "",
    RECAPTCHA_V3_SITE_KEY: "6LfxV4MtAAAAAImpxNqa_qjTBFRvzl72EGPMlDNy",
    CLIENT_ID:
      "516028534948-8fcmpcp4mg91fokmidcqqratusjj8nbd.apps.googleusercontent.com",
    SECRET: "",
  },
  //search on job portal from index page
  jobSearch: {
    Url: "https://jobs.hireneuron.ai/",
  },
  //microsoft
  microsoft: {
    API_KEY: "",
    CLIENT_ID: "696b118a-7e0b-425a-9130-0a4e28bd4265",
    SECRET: "",
  },

  facebook: {
    APP_ID: "",
  },
  bulkImport: {
    maxFile: 30,
    acceptFiles: ".doc,.pdf,.docx,.txt,.zip,.PDF,.DOCX,.TXT,.ZIP",
    maxSize: 52428800,
  },
  migrationImport: {
    maxFile: 1,
    acceptFiles: ".csv,.CSV",
    maxSize: 52428800,
  },
  questionBankImport: {
    maxFile: 1,
    acceptFiles: ".csv,.CSV",
    maxSize: 52428800,
  },
  resumeUpload: {
    maxFile: 1,
    acceptFiles: ".doc,.pdf,.docx,.txt,.PDF,.DOCX,.TXT",
    maxSize: 52428800,
  },
  jdUpload: {
    maxFile: 1,
    acceptFiles: ".doc,.pdf,.docx,.txt,.PDF,.DOCX,.TXT",
  },
  login: {
    email: {
      maxLength: 64,
    },
    password: {
      maxLength: 64,
    },
  },
  registration: {
    email: {
      maxLength: 64,
    },
    name: {
      maxLength: 64,
      fullNameRegax: "^[a-zA-Z0-9-'.\\s]{1,64}$",
    },
  },
  forgot_password: {
    email: {
      maxLength: 64,
    },
    password: {
      maxLength: 64,
    },
  },
  resetpassword: {
    password: {
      maxLength: 64,
      minLength: 8,
    },
  },
  Skill: {
    limit: 20,
  },
  Organization_addCandidate: {
    minLength: 1,
    maxLength: 50,
    panNumberRegax: "^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$",
    panNumberMinLength: 10,
    panNumberMaxLength: 10,
    licence: {
      minLength: 8,
      maxLength: 64,
    },
    uniqueId: {
      minLength: 8,
      maxLength: 64,
    },
    passportNumber: {
      minLength: 8,
      maxLength: 64,
    },
    placeOfIssue: {
      minLength: 2,
      maxLength: 64,
    },
    email: {
      maxLength: 64,
    },
    phoneNumber: {
      minLength: 8,
      maxLength: 16,
      // phoneRegax:'/^[\\s+]?[0-9-]{8,16}$/im'
      phoneRegax: "^(?=.*[0-9])[- +()0-9]+$",
    },
    reference: {
      minLength: 3,
      maxLength: 64,
    },
    qualification: {
      degree: {
        minLength: 2,
        maxLength: 100,
      },
      aggregateValue: {
        minLength: 1,
        maxLength: 5,
      },
      minLength: 3,
      maxLength: 64,
    },
    experiance: {
      //increase employer job description to 1000 character
      describeJob: {
        maxLength: 1000,
      },
      minLength: 3,
      maxLength: 64,
    },
    skill: {
      minLength: 3,
      maxLength: 64,
      minMonth: 1,
      maxMonth: 480,
    },
    achievement: {
      minLength: 3,
      maxLength: 64,
    },
    publication: {
      url: {
        maxLength: 64,
        pattern:
          "((https?[:]\\/\\/)?)((www.)[A-z0-9\\-_]+)((.[A-z0-9]+)?)(.[a-z]{2,3})",
      },
      minLength: 3,
      maxLength: 64,
    },
    certification: {
      url: {
        maxLength: 64,
      },
      certificationCode: {
        minLength: 2,
        maxLength: 10,
      },
      minLength: 3,
      maxLength: 64,
    },
    //address
    resident: {
      address: {
        minLength: 1,
        maxLength: 128,
      },
      street: {
        minLength: 1,
        maxLength: 64,
      },
      city: {
        minLength: 2,
        maxLength: 64,
      },
      state: {
        minLength: 2,
        maxLength: 64,
      },
      country: {
        minLength: 2,
        maxLength: 64,
      },
      zipcode: {
        minLength: 4,
        maxLength: 10,
      },
    },
    permanent: {
      address: {
        minLength: 1,
        maxLength: 128,
      },
      street: {
        minLength: 1,
        maxLength: 64,
      },
      city: {
        minLength: 2,
        maxLength: 64,
      },
      zipcode: {
        minLength: 4,
        maxLength: 10,
      },
    },
  },
  Organization_updateCandidate: {
    minLength: 3,
    maxLength: 16,
    nameRegax: "^[A-Za-z0-9]+$",
    fullNameRegax: "^[a-zA-Z0-9-'.\\s]{1,64}$",
    panNumberRegax: "^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$",
    panNumberMinLength: 10,
    panNumberMaxLength: 10,
    licence: {
      minLength: 8,
      maxLength: 64,
    },
    uniqueId: {
      minLength: 8,
      maxLength: 64,
    },
    passportNumber: {
      minLength: 8,
      maxLength: 64,
    },
    placeOfIssue: {
      minLength: 2,
      maxLength: 64,
    },
    email: {
      maxLength: 64,
    },
    phoneNumber: {
      minLength: 8,
      maxLength: 16,
      phoneRegax: "^(?=.*[0-9])[- +()0-9]+$",
    },
    reference: {
      minLength: 3,
      maxLength: 64,
    },

    qualification: {
      degree: {
        minLength: 2,
        maxLength: 64,
      },
      aggregateValue: {
        minLength: 1,
        maxLength: 5,
      },
      minLength: 3,
      maxLength: 64,
    },
    experiance: {
      describeJob: {
        maxLength: 500,
      },
      minLength: 3,
      maxLength: 64,
    },
    skill: {
      minLength: 3,
      maxLength: 64,
      minMonth: 1,
      maxMonth: 480,
    },
    achievement: {
      minLength: 3,
      maxLength: 64,
    },
    publication: {
      minLength: 3,
      maxLength: 64,
    },
    certification: {
      url: {
        maxLength: 64,
      },
      certificationCode: {
        minLength: 2,
        maxLength: 10,
      },
      minLength: 3,
      maxLength: 64,
    },
    resident: {
      address: {
        minLength: 1,
        maxLength: 128,
      },
      street: {
        minLength: 1,
        maxLength: 64,
      },
      city: {
        minLength: 1,
        maxLength: 64,
      },
      state: {
        minLength: 1,
        maxLength: 64,
      },
      country: {
        minLength: 1,
        maxLength: 64,
      },
      zipcode: {
        minLength: 4,
        maxLength: 10,
      },
    },
    permanent: {
      address: {
        minLength: 1,
        maxLength: 128,
      },
      street: {
        minLength: 1,
        maxLength: 64,
      },
      city: {
        minLength: 1,
        maxLength: 64,
      },
      state: {
        minLength: 1,
        maxLength: 64,
      },
      country: {
        minLength: 1,
        maxLength: 64,
      },
      zipcode: {
        minLength: 4,
        maxLength: 10,
      },
    },
  },
  Organization_addJob: {
    //this config file is used at job description in add and update job
    configOfJobDescription: [
      "bold",
      "italic",
      "unlink",
      "underline",
      "source",
      "fontsize",
      "align",
      "undo",
      "redo",
      "font",
      "strikethrough",
      "underline",
      "paragraph",
      "symbol",
      "eraser",
      "hr",
    ],
    jobDetail: {
      jobProfile: {
        minLength: 3,
        maxLength: 255,
      },
      excecutiveType: {
        minLength: 3,
        maxLength: 64,
      },
      jobShift: {
        minLength: 3,
        maxLength: 64,
      },
      experiance: {
        //range in month
        minExperiance: {
          min: 0,
          max: 2,
        },
        maxExperiance: {
          min: 1,
          max: 99,
        },
      },
      contractDuration: {
        //range in month
        min: 1,
        max: 480,
      },
      noticePeriod: {
        //range in month
        min: 0,
        max: 36,
      },
      noOfOpening: {
        min: 1,
        max: 999,
      },
      jobDescription: {
        max: 1000,
      },
    },
    organizationInfo: {
      organization: {
        minLength: 3,
        maxLength: 64,
      },
      staffingAgency: {
        minLength: 3,
        maxLength: 64,
      },
      webSite: {},
      interviewType: {
        minLength: 3,
        maxLength: 32,
      },
      contactEmail: {
        maxLength: 32,
      },
      contactPhone: {
        minLength: 8,
        maxLength: 16,
      },
      contactPersonName: {
        minLength: 3,
        maxLength: 32,
      },
      description: {
        minLength: 10,
        maxLength: 1000,
      },
    },
    jobLocation: {
      location: {
        maxLength: 150,
      },
      city: {
        minLength: 2,
        maxLength: 32,
      },
      state: {},
      country: {},
      zipCode: {
        minLength: 4,
        maxLength: 10,
      },
    },
    salaryOffered: {
      minAmount: {
        min: 0,
        max: 9999999999,
      },
      maxAmount: {
        min: 0,
        max: 9999999999,
      },
      amountLimits: {
        min: 0,
        max: 9999999999,
      },
      currency: {
        min: 2,
        max: 32,
      },
      units: {
        min: 2,
        max: 32,
      },
    },
    skills: {
      preferredSkill: {
        skill: {
          minLength: 3,
          maxLength: 64,
        },
      },
      requriedSKill: {
        skill: {
          minLength: 3,
          maxLength: 64,
        },
      },
    },

    noticePeriod: {
      minLength: 0,
      maxLength: 999,
      pattern: "^[0-9]{1,3}$",
    },
  },
  Candidate: {
    detail: {
      resume: {
        maxFile: 1,
        acceptFiles: ".doc,.pdf,.docx,.txt,.PDF,.DOCX,.TXT",
      },
    },
  },
  Recruiter: {
    detail: {
      name: {
        minLength: 2,
        maxLength: 64,
      },
      email: {
        maxLength: 64,
      },
      city: {
        maxLength: 64,
      },
      address: {
        maxLength: 64,
      },
      zipcode: {
        minLength: 4,
        maxLength: 10,
      },
      aboutOrg: {
        minLength: 10,
        maxLength: 1000,
      },
    },
  },
  Banner: {
    resolution: {
      width: 1800,
      height: 500,
      logoSize: 200000,
      bannerSize: 2000000,
    },
  },
  logo: {
    logoSize: 200000,
    minHeight: 80,
  },

  ADD_Company: {
    minLength: 1,
    maxLength: 50,
    nameRegax: "^[A-Za-z0-9'.-]+$",
    fullNameRegax: "^[a-zA-Z0-9-'.\\s]{1,64}$",
    panNumberRegax: "^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$",
    panNumberMinLength: 10,
    panNumberMaxLength: 10,
    licence: {
      minLength: 8,
      maxLength: 64,
    },
    uniqueId: {
      minLength: 8,
      maxLength: 64,
    },
    passportNumber: {
      minLength: 8,
      maxLength: 64,
    },
    placeOfIssue: {
      minLength: 2,
      maxLength: 64,
    },
    email: {
      maxLength: 64,
    },
    phoneNumber: {
      minLength: 8,
      maxLength: 16,
      // phoneRegax:'/^[\\s+]?[0-9-]{8,16}$/im'
      phoneRegax: "^(?=.*[0-9])[- +()0-9]+$",
    },
    reference: {
      minLength: 3,
      maxLength: 64,
    },
    qualification: {
      degree: {
        minLength: 2,
        maxLength: 100,
      },
      aggregateValue: {
        minLength: 1,
        maxLength: 5,
      },
      minLength: 3,
      maxLength: 64,
    },
    experiance: {
      describeJob: {
        maxLength: 150,
      },
      minLength: 3,
      maxLength: 64,
    },
    skill: {
      minLength: 3,
      maxLength: 64,
      minMonth: 1,
      maxMonth: 480,
    },
    achievement: {
      minLength: 3,
      maxLength: 64,
    },
    publication: {
      url: {
        maxLength: 64,
        pattern:
          "((https?[:]\\/\\/)?)((www.)[A-z0-9\\-_]+)((.[A-z0-9]+)?)(.[a-z]{2,3})",
      },
      minLength: 3,
      maxLength: 64,
    },
    //address
    resident: {
      address: {
        minLength: 1,
        maxLength: 128,
      },
      street: {
        minLength: 1,
        maxLength: 64,
      },
      city: {
        minLength: 2,
        maxLength: 64,
      },
      state: {
        minLength: 2,
        maxLength: 64,
      },
      country: {
        minLength: 2,
        maxLength: 64,
      },
      zipcode: {
        minLength: 4,
        maxLength: 10,
      },
    },
    company: {
      companyName: {
        minLength: 2,
        maxLength: 200,
        regex: /^[.@&]?[a-zA-Z0-9 ]+[ !.@&()]?[ a-zA-Z0-9!()]+/,
      },
      contactPerson: {
        minLength: 2,
        maxLength: 200,
        regex: /^[a-zA-Z0-9][a-zA-Z0-9-'.\s]{1,200}$/,
      },
      url: {
        regex:
          /((https?\s*:\s*\/+)|(www\.))[a-z\-]+\.?[a-z\d\-]+\.[a-z]+(:[\d]{2,5})?[\/a-z¡¿áàâäãąæćčçďéèêëěęğıíìİîïłńňñóòôöõőœřśšşßťúùûüůűýÿźżžA-Z\-_ ?=0-9\.\+~%]*\s*/,
      },
      aboutCompany: {
        maxlength: 1000,
      },
      logo: {
        logoSize: 200000,
      },
      phoneNumber: {
        regex: /^[0-9-()\\s]{6,16}$/,
      },
    },
  },
};
